import { AudioSplitterView } from './audio-splitter/AudioSplitterView'
import { useAudioSplitter } from './audio-splitter/useAudioSplitter'

export function AudioSplitter(props) {
  const model = useAudioSplitter(props)
  return <AudioSplitterView {...model} />
}
